import React from 'react';
import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  display: flex;
  width: 300px;
  height: 110px;
  color: #666;
  background-color: #FFF;
  font-size: 1rem;
  margin-top: 20px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 18px;
  border: 1px solid #666;
  resize: none;
  box-shadow: 1px 2px #666;
  &:hover {
    border: 1px solid #666;
    opacity: 0.9;
  } 
  
  @media (max-width: 1023px) {
    width: 300px;
  }
  @media (max-width: 600px) {
    width: 200px;
  }
  @media (max-width: 600px) {
    width: 160px;
  }
  
   ${props => props.styles }
`;


const TextArea = (props) => (
    <StyledTextArea
      rows="3"
      placeholder={props.placeholder}
      {...props}
      value={props.children}
    ></StyledTextArea>);

export default TextArea;


// WEBPACK FOOTER //
// ./src/Components/TextArea.js